import { useLang } from "../hooks/useLanguage";

const Marquee = () => {
  const { t } = useLang();
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {t.MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif-lux italic font-light text-2xl sm:text-3xl text-ivory/55 px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-champagne/70 shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className="bg-[#141414] border-y hairline-dark py-7 overflow-hidden"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
};

export default Marquee;
